import { render, staticRenderFns } from "./modalAnadirCompra.vue?vue&type=template&id=06b7b32a&scoped=true"
import script from "./modalAnadirCompra.vue?vue&type=script&lang=js"
export * from "./modalAnadirCompra.vue?vue&type=script&lang=js"
import style0 from "./modalAnadirCompra.vue?vue&type=style&index=0&id=06b7b32a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b7b32a",
  null
  
)

export default component.exports